import { useState } from "react";
import Image from "next/image";
import { Col, Row, Container, Accordion, Button } from "react-bootstrap";
import { customerServices } from "@/services/customerServices";
import { healerServices } from "@/services/healerServices";
import Layout from "@/components/layout";
import Link from "next/link";
import dynamic from "next/dynamic";
import styles from "@/styles/JoinAsHealer.module.css";
import Head from "next/head";
import Testimonial from "@/components/healer/testimonials";

const OwlCarousel = dynamic(() => import("react-owl-carousel"), {
  ssr: false,
});

const AboutUs = (props) => {
  const [testimonials, setTestimonial] = useState(props?.testimonials ?? []);
  const [joinHealerMeta, setJoinHealerMeta] = useState(
    props?.joinAsAHealerMeta ?? {}
  );
  const [next, setNext] = useState(false);

  return (
    <>
      <Head>
        <title>{joinHealerMeta?.meta?.og_title}</title>
        <meta name="title" content={joinHealerMeta?.meta?.meta_title}></meta>
        <meta
          name="description"
          content={joinHealerMeta?.meta?.meta_description}
        ></meta>
        <meta
          name="keywords"
          content={joinHealerMeta?.meta?.meta_keywords}
        ></meta>
        <meta property="og:type" content="website"></meta>
        <meta
          property="og:title"
          content={joinHealerMeta?.meta?.og_title}
        ></meta>
        <meta
          property="og:image"
          content={joinHealerMeta?.meta?.og_image}
        ></meta>
        <link
          rel="canonical"
          href="https://www.zenkify.com/join-as-a-healer"
        ></link>
        <meta
          property="og:description"
          content={joinHealerMeta?.meta?.meta_description}
        ></meta>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={joinHealerMeta?.meta?.meta_title} />
        <meta
          name="twitter:description"
          content={joinHealerMeta?.meta?.meta_description}
        />
        <meta name="twitter:image" content={joinHealerMeta?.meta?.og_image} />
        <meta
          property="og:url"
          content="https://www.zenkify.com/join-as-a-healer"
        />
        <meta property="og:site_name" content="Zenkify" />
        <meta property="og:image:alt" content="zenkify join as a healer" />
        <meta
          property="og:image"
          content={joinHealerMeta?.meta?.og_image}
        ></meta>
      </Head>
      <section
        className={`${styles["section-banner"]} ${styles["banner-page"]}`}
        style={{ background: "url(/images/join-as-healer/about-banner.jpg)" }}
      >
        <Container>
          <Row>
            <Col md={8} className="m-auto">
              <div className={styles["inner-content"]}>
                <h1 className={styles["banner-title"]}>
                  Start Healing with Zenkify – No Listing Fee!
                </h1>
                <p className={styles["joinhealerDescription"]}>
                  List your services, schedule sessions, and get discovered —
                  completely free to start.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles["why-zenkify"]}>
        <Container>
          <Row>
            <Col lg={11} className="m-auto mb-4">
              <div className="section-title">
                <h3 className="title">Why Zenkify Rocks:</h3>
                {/* <p>
                  Joining Zenkify as Energy Healer can be a game-changer for
                  your practice. By embracing the digital realm, you can unlock
                  a multitude of benefits that amplify your impact and enhance
                  your professional journey. From extending your reach to
                  collaborating with like-minded practitioners, accessing
                  valuable resources to enjoying flexibility in your schedule,
                  this platform provide a wealth of opportunities.{" "}
                </p> */}
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <div className={styles["outerbox-content"]}>
                <div className={styles["innerbox"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/connect.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <div className={styles["content"]}>
                    <h4>Connect with Clients Worldwide</h4>
                    <p>
                      Zenkify hooks you up with clients from all corners of the
                      globe. No more boundaries – spread those healing vibes
                      worldwide!
                    </p>
                  </div>
                </div>
                <div className={styles["innerbox"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/tech-hassles.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <div className={styles["content"]}>
                    <h4>Tech Made Easy</h4>
                    <p>
                      Say bye-bye to web development headaches. Zenkify lets you
                      skip the tech drama and just set up a cool profile. No
                      need to hustle for a website!
                    </p>
                  </div>
                </div>
                <div className={styles["innerbox"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/commission-zone.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <div className={styles["content"]}>
                    <h4>No Hidden Fees</h4>
                    <p>
                      We won&apos;t dip into your hard-earned cash. Zero
                      commissions on your sessions and courses. Take as many
                      energy healing sessions as you want, and undertake courses
                      – we won&apos;t charge you a single penny! It&apos;s all
                      about you and your healing journey.
                    </p>
                  </div>
                </div>
                {/* <div className={styles["innerbox"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Penny-Pincher-Paradise.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <div className={styles["content"]}>
                    <h4>Penny-Pincher&apos;s Paradise</h4>
                    <p>
                      Forget the wallet-draining costs of websites. Zenkify is
                      your budget-friendly ticket to having an online presence
                      without burning a hole in your pocket.
                    </p>
                  </div>
                </div> */}
              </div>
            </Col>
            <Col lg={4} className="align-self-center">
              <div className={styles["centerimage-why"]}>
                <Image
                  height={500}
                  width={500}
                  src="/images/rocks-center.png"
                  alt="zenkify-rocks-center"
                ></Image>
              </div>
            </Col>
            <Col lg={4}>
              <div
                className={
                  styles["outerbox-content"] + " " + styles["outer-right"]
                }
              >
                {/* <div className={styles["innerbox"]}>
                  <div className={styles["content"]}>
                    <h4>Fort Knox-Level Security</h4>
                    <p>
                      Zenkify’s got your back with super-safe transactions
                      through Stripe. Trusted by more than 36000 companies
                      worldwide, so you know your money’s in good hands.
                    </p>
                  </div>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Fort-Knox-Level-Security.svg"
                      alt="connect"
                    ></Image>
                  </div>
                </div> */}

                <div className={styles["innerbox"]}>
                  <div className={styles["content"]}>
                    <h4>Bookings Made Easy</h4>
                    <p>
                      You decide when and for how long – making life breezy for
                      you and your clients.
                    </p>
                  </div>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/bookings.svg"
                      alt="connect"
                    ></Image>
                  </div>
                </div>
                <div className={styles["innerbox"]}>
                  <div className={styles["content"]}>
                    <h4>Grow your Practice</h4>
                    <p>
                      Reach more clients, offer more sessions, and grow with
                      purpose.
                    </p>
                  </div>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/cash-flow.svg"
                      alt="connect"
                    ></Image>
                  </div>
                </div>
                <div className={styles["innerbox"]}>
                  <div className={styles["content"]}>
                    <h4>Track your Growth</h4>
                    <p>From bookings to earnings—know what’s working.</p>
                  </div>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/data-geek.svg"
                      alt="connect"
                    ></Image>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="text-center mt-3">
              <Link href="/auth/healer/social/signup" className="theme-btn">
                Join Today <i className="ri-arrow-right-line"></i>
              </Link>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles["standout-section"]}>
        <Container className={styles["container"]}>
          <Row>
            <Col lg={10} className="m-auto">
              <div className="section-title">
                <h3 className="title">Why Zenkify Stands Out</h3>
                <p>
                  With Zenkify, you get all the essential tools and services
                  needed to elevate your energy healing practice, all at a
                  fraction of the cost compared to setting up and maintaining
                  your own website. It&apos;s a hassle-free and cost-effective
                  solution for energy healers looking to thrive in the digital
                  space.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={3}>
              <Link
                href="/auth/healer/social/signup"
                className={styles["theme-btn"] + " " + "theme-btn"}
              >
                Joining Zenkify
              </Link>
              <div className={styles["standout-items"]}>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Client Acquisition and Global Reach</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Flexible Scheduler</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Secured Payment Gateway</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Customized Dashboard</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Marketing and Promotion</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Expansion of Business</h6>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <div className={styles["price-compare"]}>
                <div className={styles["join-box"]}>
                  <div className={styles["pricebox"]}>
                    <h6>Joining Zenkify</h6>
                    <h3>FREE</h3>
                    {/* <span>month</span> */}
                  </div>
                </div>
                <div className={styles["join-box"] + " " + styles["build-own"]}>
                  <div className={styles["pricebox"]}>
                    <h6>DIY Website</h6>
                    <h3>$150 - $300</h3>
                    <span>month</span>
                  </div>
                </div>
              </div>
            </Col>
            <Col lg={3}>
              <Link
                href="/auth/healer/social/signup"
                className={styles["theme-btn"] + " " + "theme-btn"}
              >
                DIY Website
              </Link>
              <div
                className={
                  styles["standout-items"] + " " + styles["right-items"]
                }
              >
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Web Hosting & Domain Registration</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Scheduler Implementation</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Payment Gateway Fee</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Business Setting Cost</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Website Maintenance and IT Management Fee</h6>
                </div>
                <div className={styles["standout-card"]}>
                  <span>
                    <i className="ri-checkbox-blank-circle-fill"></i>
                  </span>
                  <h6>Marketing and Advertising Cost and Efforts</h6>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col className="mt-4">
              <div className={styles["subscribe-btn"]}>
                <h4>Subscribe today and pursue your passion hassle-free</h4>
                <Link href="/auth/healer/social/signup" className="theme-btn">
                  Join Zenkify Today! <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      {/* <section className={styles["reasons-choose"]}>
        <Container>
          <Row>
            <Col lg={4} className="align-self-center">
              <div className={styles["reasons-content"]}>
                <h3>Reasons to Choose Zenkify</h3>
                <p>
                  Step into Zenkify, where your healing journey starts with
                  ease.Embrace a seamless journey and prepare to soar toward
                  your dreams with us.
                </p>
                <Link href="/auth/healer/social/signup" className="theme-btn">
                  Join Zenkify <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </Col>
            <Col lg={4} className="align-self-center">
              <div className={styles["middle-image"]}>
                <Image
                  height={300}
                  width={300}
                  src="/images/reasons-choose.svg"
                  alt="connect"
                ></Image>
              </div>
            </Col>
            <Col lg={4}>
              <div className={styles["reasons-items"]}>
                <div className={styles["items-box"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Worldwide-Client-Outreach.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <h6>Worldwide Client Outreach</h6>
                </div>
                <div className={styles["items-box"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Adaptable-Scheduling-Options.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <h6>Adaptable Scheduling Options</h6>
                </div>
                <div className={styles["items-box"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Safe-Payment-Handling.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <h6>Safe Payment Handling</h6>
                </div>

                <div className={styles["items-box"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Customized-Dashboard-Experience.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <h6>Customized Dashboard Experience</h6>
                </div>
                <div className={styles["items-box"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Marketing-Assistance.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <h6>Marketing Assistance</h6>
                </div>
                <div className={styles["items-box"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Business-Growth-Opportunities.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <h6>Business Growth Opportunities</h6>
                </div>
                <div className={styles["items-box"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Note-taking-and-Recording-Feature.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <h6>Note-taking and Recording Feature</h6>
                </div>
                <div className={styles["items-box"]}>
                  <div className={styles["icon"]}>
                    <Image
                      height={50}
                      width={50}
                      src="/images/Social-Media-Promotion.svg"
                      alt="connect"
                    ></Image>
                  </div>
                  <h6>Social Media Promotion</h6>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section> */}
      <section className={styles["healing-network"]}>
        <div className={styles["flower-top-left"]}>
          <Image
            height={130}
            width={130}
            src="/images/goldern-flower-icon.svg"
            alt="flower"
          />
        </div>
        <div className={styles["flower-top-right"]}>
          <Image
            height={100}
            width={100}
            src="/images/flower-2.svg"
            alt="flower"
          />
        </div>
        <Container>
          <Row>
            <Col md={11} className="m-auto">
              <div className={styles["section-title"]}>
                <h3 className={styles["title"]}>Building a Healing Network</h3>
                <p>
                  At Zenkify, we believe in the power of building connections.
                  Join our platform to network with fellow healers, sharing
                  experiences and knowledge. Together, we create a supportive
                  community where we grow, learn, and heal, amplifying the
                  positive impact of energy healing worldwide.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col md={4} className="order-md-2">
              <Image
                height={590}
                width={542}
                src="/images/join-as-healer/healing-network.svg"
                alt="Building a Healing Network"
              />
            </Col>
            <Col md={7}>
              <div className={styles["cardSectionBody"]}>
                <div className={styles["cardSection"]}>
                  <h3>Networking and Collaboration </h3>
                  <p>
                    Connect with healers from diverse backgrounds, fostering
                    opportunities for collaboration, knowledge sharing, and
                    professional growth.
                  </p>
                </div>
                <div className={styles["cardSection"]}>
                  <h3>Enhanced Credibility</h3>
                  <p>
                    Zenkify&apos;s trusted platform adds credibility to
                    healers&apos; practices, showcasing reviews and ratings from
                    past clients.
                  </p>
                </div>
                <div className={styles["cardSection"]}>
                  <h3>Resources and Training</h3>
                  <p>
                    Zenkify offers educational resources and training materials
                    on energy healing techniques, business development, and
                    self-improvement.
                  </p>
                </div>
                <div className={styles["cardSection"]}>
                  <h3>Continuous Support</h3>
                  <p>
                    Connect with a community of healers, administrators, and
                    moderators for ongoing support, guidance, and feedback.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={1}></Col>
          </Row>
        </Container>
      </section>
      <Testimonial />
      <section className="faq-section">
        <Container>
          <Row>
            <Col lg={10} className="m-auto">
              <div className="section-title">
                <h3 className="title">FAQ’s</h3>
                <p>
                  Get Answers to your Questions.Learn and Discover Energy
                  Healing Benefits, Sessions, Techniques, and more. Clear your
                  Doubts and make an Informed Choice. Explore Energy Healing
                  with our FAQs.
                </p>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={10} className="m-auto">
              <Accordion
                defaultActiveKey="0"
                className="faq-accordion"
                id="accordionExample"
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    <span>
                      Do you charge any commission on sessions and course fees
                      that we charge from our clients?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      {" "}
                      No, we don&apos;t charge a single penny. You may take n
                      number of sessions; we won&apos;t charge anything.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    <span>
                      How can I create and customize my profile on Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Creating and customizing your profile is easy. Simply
                      navigate to your account settings, and you&apos;ll find
                      options to personalize your profile with details about
                      your healing practice.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    <span>
                      Is there a limit to the number of sessions I can schedule
                      on Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      No, there is no limit. You have the flexibility to
                      schedule as many sessions as needed to accommodate your
                      clients&apos; needs.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    <span>
                      What tools does Zenkify provide to help manage my schedule
                      efficiently?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify offers an integrated scheduling system that allows
                      you to manage and organize your sessions effortlessly. You
                      can set your availability and let clients book
                      appointments at their convenience.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    <span>
                      Can I offer both in-person and virtual sessions through
                      Zenkify?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, absolutely. Zenkify supports both in-person and
                      virtual sessions, providing you with the flexibility to
                      connect with clients in the way that suits you and them
                      best.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                  <Accordion.Header>
                    <span>How are payments handled on Zenkify?</span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify has a secure payment gateway that facilitates easy
                      transactions between you and your clients. You can set
                      your own rates, and payments are processed seamlessly.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                  <Accordion.Header>
                    <span>
                      Is there any training or guidance available to improve my
                      online presence and attract more clients?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, Zenkify offers resources and guides to enhance your
                      online presence, helping you reach a wider audience and
                      attract more clients to your healing practice.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                  <Accordion.Header>
                    <span>
                      Can I use Zenkify if I already have an existing website
                      for my healing practice?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Certainly. Zenkify can complement your existing website by
                      providing additional tools and services to streamline your
                      business operations and client management.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="8">
                  <Accordion.Header>
                    <span>
                      How does Zenkify help me in marketing my services?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Zenkify provides marketing features to promote your
                      services, including client reviews, promotional offers,
                      and a platform to showcase your expertise, making it
                      easier for clients to discover and connect with you.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="9">
                  <Accordion.Header>
                    <span>
                      Is there a support team available to assist if I encounter
                      any issues on the platform?
                    </span>
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, we have a dedicated support team ready to assist you
                      with any issues or questions you may have while using
                      Zenkify. Simply reach out to us through our support
                      channels, and we&apos;ll be happy to help.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>
      <section className={styles["getStarted-2"]}>
        <div className={styles["flower-top-left"]}>
          <Image
            height={130}
            width={130}
            src="/images/goldern-flower-icon.svg"
            alt="flower"
          />
        </div>
        <div className="container-fluid">
          <Row>
            <Col lg={8} className="m-auto">
              <div className={styles["content-inner"]}>
                <h3>Expand Your Reach, Transform Lives with Zenkify</h3>
                <Link
                  href="/auth/healer/social/signup"
                  className={styles["theme-btn"]}
                >
                  Get Started Today <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </section>
    </>
  );
};

export default AboutUs;

AboutUs.getLayout = function getLayout(page) {
  return <Layout>{page}</Layout>;
};

// ssr
export async function getServerSideProps() {
  const fetchTestimonials = async () => {
    const res = await customerServices.getTestimonials();
    if (res.status) {
      return res.data;
    } else {
      toast.error(res.message, {
        autoClose: 5000,
      });
    }
  };

  const fetchJoinAsAHealerMeta = async () => {
    try {
      const res = await healerServices.getMetaInformation("join-as-a-healer");
      if (res.status) {
        return res.data;
      }
    } catch (error) {
      console.error("Error fetching slider data:", error);
    }
  };

  const testimonials = (await fetchTestimonials()) ?? {};
  const joinAsAHealerMeta = (await fetchJoinAsAHealerMeta()) ?? {};

  // Pass data to the page via props
  return { props: { testimonials, joinAsAHealerMeta } };
}
